<template>
  <div class="page-upload-web xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">添加网页链接</div>
          <div
            class="xc-modal-close"
            @click="layerClose"
          ></div>
        </div>
        <div class="xc-modal-body xc-flex-center">
          <template v-if="channel == '0'">
            <form class="form">
              <xc-form-item
                label="播放时长(秒)"
                class="xc-form-item-fixed"
                required
                :error="errors.first('duration')"
              >
                <input
                  type="text"
                  class="xc-input"
                  v-model="data.duration"
                  placeholder="请输入秒数"
                  name="duration"
                  data-vv-as="播放时长"
                  v-validate="'required|min_value:1'"
                >
              </xc-form-item>
              <div class="link">
                <xc-form-item
                  label="网页链接"
                  class="xc-form-item-fixed"
                  required
                  :error="errors.first('link')"
                >
                  <input
                    type="url"
                    class="xc-input"
                    v-model="data.link"
                    name="link"
                    v-validate="'required|url'"
                    data-vv-as="网页链接"
                  >
                </xc-form-item>
                <a
                  class="btn-check xc-btn xc-btn-primary"
                  @click="checkUrl"
                >检测</a>
              </div>
            </form>
            <div
              class="web-preview"
              v-if="previewUrl"
            >
              <iframe :src="previewUrl"></iframe>
            </div>
          </template>
          <template v-if="channel == '1'">
            <form
              class="form"
              name="web"
            >
              <div class="xc-form-inline">
                <xc-form-item
                  label="网址名称"
                  class="xc-form-item-fixed"
                >
                  <input
                    type="text"
                    class="xc-input"
                    v-model="data.fileName"
                    placeholder="请输入名称"
                  >
                </xc-form-item>
                <xc-form-item
                  label="选择分组"
                  required=""
                  :error="errors.first('groupId')"
                >
                  <select
                    name="groupId"
                    class="xc-select"
                    v-validate="'required'"
                    data-vv-as="分组"
                    v-model="fileGroupId"
                  >
                    <option value="">请选择</option>
                    <template v-if="fileGroups.length">
                      <option
                        v-for="(item,index) in fileGroups"
                        :key="index"
                        :value="item.fileGroupId"
                      >{{item.fileGroupName}}</option>
                    </template>
                  </select>
                </xc-form-item>
              </div>
              <div class="xc-form-inline xc-form-margin-bottom">
                <xc-form-item
                  label="网页链接"
                  class="xc-form-item-fixed xc-form-item-style-resete"
                  required
                  :error="errors.first('link')"
                >
                  <input
                    type="url"
                    class="xc-input xc-input-resete"
                    v-model="data.link"
                    name="link"
                    v-validate="'required|url'"
                    data-vv-as="网页链接"
                  >

                </xc-form-item>
                <a
                  class="btn-check xc-btn xc-btn-primary"
                  @click="checkUrl"
                >检测</a>
              </div>
            </form>
            <div
              class="web-preview"
              v-if="previewUrl"
            >
              <iframe
                :src="previewUrl"
                name="child"
              ></iframe>
            </div>
          </template>
        </div>
        <div class="xc-modal-footer xc-flex-center">
          <div class="xc-btn-group">
            <div
              class="xc-btn xc-btn-default"
              @click="layerClose"
            >取消</div>
            <div
              class="xc-btn xc-btn-primary"
              @click.prevent="submit"
            >确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/libs/vee-validate'
import myLayerImport from '@/libs/myLayer'
import material from "@/api/material"

myLayerImport();

export default {
  name: 'materialUploadImage',
  data() {
    return {
      // 来源渠道 0、节目编辑器（图片上传） 1、素材库（图片上传）
      channel: this.$route.query.channel || 0,
      fileGroups: [],  //素材分组
      fileGroupId: this.$route.query.fileGroupId || '',  //当前分组ID
      data: {},
      previewUrl: null,
    }
  },

  created() {
    if (this.channel == 1) {
      // 获取素材分组
      material.getFileGroup().then((success) => {
        this.fileGroups = success.data;
      })
    }
  },

  methods: {
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },
    submit() {

      this.$validator.validateAll().then(async validate => {

        if (validate) {

          if (!this.data.fileName) {
            this.data.fileName = (await material.getTitleByUrl(this.data.link)).data;
          }

          const returnData = {
            url: this.data.link,
            fileName: this.data.fileName,
            fileType: 'web',
            groupId: this.data.groupId,
            duration: Number(this.data.duration * 1000),
            size: 1,
            fileGroupId: this.fileGroupId,
          }


          // 将素材入库
          material.uploadSure({
            files: JSON.stringify([{
              url: returnData.url,
              fileName: returnData.fileName,
              fileType: returnData.fileType,
              groupId: returnData.fileGroupId,
            }]),
          }).then(() => {
            parent.window.webUploadSubmit(returnData);
            this.layerClose();
          })
        }
      })
    },
    checkUrl() {
      if (!this.data.link) {
        this.$message.error("请输入网址")
        return;
      }

      this.previewUrl = this.data.link;
    }
  }
}
</script>

<style lang="scss" >
.page-upload-web {
  .xc-form-item-style-resete {
    width: 520px;
  }

  .xc-form-margin-bottom {
    padding-bottom: 16px;
  }

  .xc-form-inline .xc-input-resete {
    width: 100%;
  }

  .xc-form-item-label {
    min-width: 90px;
  }

  .link {
    position: relative;
    .btn-check {
      position: absolute;
      right: -90px;
      top: 0;
    }
  }

  .web-preview {
    width: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 274px;
      background-color: #ffffff;
      border-radius: 8px;
      border: solid 1px #cfd5e0;
    }
  }
}
</style>
